import LoginComponent from "../components/Login/Login";

export default function Login() {
  return <LoginComponent />;
}
